import type { ComponentPropsWithoutRef } from 'react';

import queryString from 'query-string';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import { OAUTH_SIGNUP } from '@/lib/routes/privateRoutes';

import AppleIcon from '../Icon/AppleIcon';
import GoogleIcon from '../Icon/GoogleIcon';

const TypeSSOSignIn = {
    apple: {
        sign_in: { token: 'commons:sign_in_apple' },
        sign_up: { token: 'commons:sign_up_apple' }
    },
    google: {
        sign_in: { token: 'commons:sign_in_google' },
        sign_up: { token: 'commons:sign_up_google' }
    }
} as const;

type ButtonGoogleSignInPropsType = Omit<ComponentPropsWithoutRef<'button'>, 'type'> & {
    type: 'sign_in' | 'sign_up';
    isAuthorize?: () => boolean;
    queryParameters?: Record<string, string | number>;
    channel: 'google' | 'apple';
};

function ButtonGoogleSignIn({
    type = 'sign_in',
    isAuthorize = () => true,
    queryParameters,
    channel,
    className,
    ...restProps
}: ButtonGoogleSignInPropsType) {
    const { t } = useTranslation();
    const icon = {
        google: <GoogleIcon />,
        apple: <AppleIcon />
    };

    return (
        <button
            className={`oauth-material-button min-h-12 w-full max-w-full bg-transparent hover:bg-transparent ${className}`}
            type="button"
            onClick={() => {
                if (isAuthorize()) {
                    const params = {
                        ...queryParameters,
                        type
                    };
                    window.location.assign(
                        `${OAUTH_SIGNUP[channel]}?${queryString.stringify(params, {
                            arrayFormat: 'bracket'
                        })}`
                    );
                }
            }}
            {...restProps}>
            <div className="oauth-material-button-state"></div>
            <div className="oauth-material-button-content-wrapper">
                <div className="oauth-material-button-icon">{icon[channel]}</div>
                <span className="oauth-material-button-contents">
                    {t(TypeSSOSignIn[channel][type].token)}
                </span>
                <span className="hidden">{t(TypeSSOSignIn[channel][type].token)}</span>
            </div>
        </button>
    );
}

export default ButtonGoogleSignIn;
